/* import __COLOCATED_TEMPLATE__ from './saml-scim-settings-accordion.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class SamlScimSettingsAccordion extends Component {
  @tracked openSectionId;
}
